import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'units/'

const initialState = {
    units: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getUnits = createAsyncThunk('units/gau', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleUnits = createAsyncThunk('units/gsd', async (unitID, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}${unitID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addUnit = createAsyncThunk('units/ad', async (deptData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, deptData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const editUnit = createAsyncThunk('units/ed', async (deptData, thunkAPI) => {
    try {
        const result = await axios.put(`${API_URL}${deptData.unitID}`, deptData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteUnit = createAsyncThunk('units/dd', async (deptID, thunkAPI) => {
    try {
        const result = await axios.delete(`${API_URL}${deptID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const unitSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.units = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getUnits.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getUnits.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.units = action.payload
            })
            .addCase(getUnits.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.units = []
            })
    }
})

export const { reset } = unitSlice.actions

export default unitSlice.reducer